// ============================================================================
// routesPubliques.js — Les pages publiques à JETON, reconnues dès l'URL
// ============================================================================
// Demande Pierre (28/09/2026) : un lien de convocation mettait ~15 s à
// s'ouvrir au premier passage. Aramis démarrait comme pour un utilisateur
// connecté (écouteurs Firestore, ~1,3 Mo de données, service worker) AVANT de
// charger la petite page publique. Ces pages sont désormais montées AVANT
// <App/> (src/index.js → src/AppPublique.js), comme celles du vote de l'AG.
//
// Une seule liste : App.jsx garde ses routes en SECOURS (jamais de page
// blanche), et toute nouvelle page à jeton s'ajoute ICI.
// ============================================================================

export const VUES_PUBLIQUES_A_JETON = [
  "themis-presence",
  "themis-pouvoir",
  "themis-pouvoir-confirmation",
  "themis-emargement",
  "themis-repas",
  // Export comptable mensuel au cabinet (02/10/2026) : lien du courriel.
  "export-comptable",
  // Médiathèque (12/10/2026) : la page des invités sans compte, lien de l'annonce.
  "mediatheque-invite",
  // Mes formations (16/10/2026) : émargement, espace du formateur, page d'une
  // personne sans compte.
  "formation-emargement",
  "formation-formateur",
  "mes-formations-invite",
  // Pôle RH (18/10/2026) : l'accord d'une personne en mobilité entre mutuelles.
  "rh-mobilite",
  // PV signé (03/11/2026) : la signature d'un PV ou d'un compte rendu, lien du courriel.
  "pv-signature",
];

// Pages publiques SANS jeton : « Recevoir mon lien » (Mes formations), qui
// demande l'adresse et donne toujours la même réponse ; la fenêtre de lecture
// d'un document ouverte depuis une page à jeton (20/10/2026), dont l'adresse ne
// porte RIEN : le jeton lui est confié par postMessage (ouvertureFenetre.js).
export const VUES_PUBLIQUES_SANS_JETON = ["mes-formations-lien", "formation-document-jeton"];

/**
 * La page publique désignée par l'URL, ou null (on retombe alors dans App).
 * Exige un jeton non vide (sauf VUES_PUBLIQUES_SANS_JETON) et la racine du site.
 * → { vue, token, p, r }
 */
export function routePublique(loc) {
  if (!loc) return null;
  const chemin = String(loc.pathname || "/");
  if (chemin !== "/" && chemin !== "/index.html") return null;
  let params;
  try { params = new URLSearchParams(loc.search || ""); } catch { return null; }
  const vue = params.get("view") || "";
  const token = (params.get("t") || "").trim();
  if (VUES_PUBLIQUES_SANS_JETON.includes(vue)) return { vue, token: "", p: "", r: "" };
  if (!VUES_PUBLIQUES_A_JETON.includes(vue) || !token) return null;
  return { vue, token, p: params.get("p") || "", r: params.get("r") || "" };
}
